import { Box, Grid, Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import Groups2TwoToneIcon from "@mui/icons-material/Groups2TwoTone";
import NfcTwoToneIcon from "@mui/icons-material/NfcTwoTone";
import { DescriptionTwoTone } from "@mui/icons-material";
import BadgeTwoToneIcon from "@mui/icons-material/BadgeTwoTone";
import { useAuth } from "../../services/auth";

const NFCList = () => {
  const navigate = useNavigate();
  const { role } = useAuth();
  let nfcTypes = [
    {
      name: "NFC",
      icon: <NfcTwoToneIcon color="action" fontSize="large"></NfcTwoToneIcon>,
      route: "General",
    },
    {
      name: "Tickets NFC",
      icon: (
        <DescriptionTwoTone
          color="action"
          fontSize="large"
        ></DescriptionTwoTone>
      ),
      route: "Ticket",
    },
    {
      name: "Employees NFC",
      icon: (
        <Groups2TwoToneIcon
          color="action"
          fontSize="large"
        ></Groups2TwoToneIcon>
      ),
      route: "Employees",
    },
    {
      name: "MemberShip NFC",
      icon: (
        <BadgeTwoToneIcon color="action" fontSize="large"></BadgeTwoToneIcon>
      ),
      route: "MemberShip",
    },
  ];

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: "#F7F9FB",
    padding: 5,
    textAlign: "center",
    color: "#1C1C1C",
    width: "500px",
  }));

  return (
    <>
      {role === "Company" || role === "Admin" ? (
        <Box sx={{ flexGrow: 1, mt: 2 }}>
          <Grid
            container
            spacing={{ xs: 2, md: 10 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
          >
            {nfcTypes.map((report, index) => (
              <Grid item xs={2} sm={6} md={6} key={index}>
                <Item>
                  <Box sx={{ flexGrow: 1, display: "flex" }}>
                    <Box
                      sx={{
                        flex: "1",
                        mt: 1,
                        mr: 2,
                        fontSize: "24px",
                        textAlign: "right",
                      }}
                    >
                      {report.icon}
                    </Box>
                    <Box
                      sx={{ flex: "3", textAlign: "left", cursor: "pointer" }}
                      onClick={() => navigate(report.route)}
                    >
                      <Box sx={{ fontWeight: "bold" }}>{report.name}</Box>
                      <Box>Details ...</Box>
                    </Box>
                  </Box>
                </Item>
              </Grid>
            ))}
          </Grid>
        </Box>
      ) : (
        <Item>
          <Box sx={{ display: "flex" }}>
            <Box
              sx={{
                flex: "1",
                mt: 1,
                mr: 2,
                fontSize: "24px",
                textAlign: "right",
              }}
            >
              <DescriptionTwoTone color="action" fontSize="large" />
            </Box>
            <Box
              sx={{ flex: "3", textAlign: "left", cursor: "pointer" }}
              onClick={() => navigate("Ticket")}
            >
              <Box sx={{ fontWeight: "bold" }}>Tickets NFC</Box>
              <Box>Details ...</Box>
            </Box>
          </Box>
        </Item>
      )}
    </>
  );
};

export default NFCList;
